import React from 'react';

const SeniorityLevelFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.7969 7.6001H15.5969C16.4456 7.6001 17.2595 7.93724 17.8596 8.53736C18.4597 9.13747 18.7969 9.9514 18.7969 10.8001C18.7969 11.6488 18.4597 12.4627 17.8596 13.0628C17.2595 13.663 16.4456 14.0001 15.5969 14.0001H14.7969"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M2 7.6001H14.8V14.8001C14.8 15.6488 14.4629 16.4627 13.8627 17.0628C13.2626 17.663 12.4487 18.0001 11.6 18.0001H5.2C4.35131 18.0001 3.53737 17.663 2.93726 17.0628C2.33714 16.4627 2 15.6488 2 14.8001V7.6001Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M5.20312 2V4.4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M8.39844 2V4.4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M11.6016 2V4.4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
};

export default SeniorityLevelFilterIcon;
